export function getTitle(params, cellMetaData) {
    // const rowIndex = params.data.uniqueId;
    const rowIndex = params?.data?.uniqueId ?? "";
    const columnKey = params.colDef.field;
    const columnOptions = params.colDef.cellRendererParams.columnOptions;
    let isPercentage = false
  
    if (!params.data) {
      return "";
    }
  
    if (params.data.row_id == "+" || !rowIndex) {
      return "";
    }
  
    if (
      params.columnTypeId === "14" &&
      params.value &&
      params.value !== "" &&
      params.value !== "+r0w" &&
      params.value !== "+" &&
      !params.store.validateEmail(params.value)
    ) {
      return "Invalid email";
    }

    if (
      params.columnTypeId == "24" &&
      params.value &&
      params.value !== "" &&
      params.value !== "+r0w" &&
      params.value !== "+" &&
      !params.store.validateUrl(params.value)
    ) {
      return "Invalid url";
    }

    if(params.columnTypeId == "22"){
      isPercentage = true
    }
  
    if (columnOptions?.is_mandatory && !params.value) {
      return "this field is mandatory";
    }
  
    if (columnOptions?.min_length && columnOptions.min_length > params.value?.toString().length) {
      return (
        "Length less than min limit of " + columnOptions.min_length + " chars"
      );
    }
  
    if (columnOptions?.max_length && columnOptions.max_length < params.value?.toString().length) {
      return (
        "Length more than max limit of " + columnOptions.max_length + " chars"
      );
    }
    if (
      columnOptions?.max_value &&
      Number(columnOptions.max_value) < Number(params.value)
    ) {
      let max_value = isPercentage ? ((columnOptions.max_value)*100).toFixed(2) + " %" : columnOptions.max_value
      return "Value greater than max value of " + max_value ;
    }
  
    if (
      columnOptions?.min_value &&
      Number(columnOptions.min_value) > Number(params.value)
    ) {
      let min_value = isPercentage ? ((columnOptions.min_value)*100).toFixed(2) + " %" : columnOptions.min_value
      return "Value lesser than min value of " + min_value ;
    }
  
    if (
      !cellMetaData?.[rowIndex]?.[columnKey]?.isError &&
      !cellMetaData?.[rowIndex]?.isError
    ) {
      return "";
    }
  
    return (
      cellMetaData?.[rowIndex]?.[columnKey]?.hoverMessage ||
      cellMetaData?.[rowIndex]?.hoverMessage ||
      ""
    );
  }